import { setPage } from '../../action/system'
import { getPagesFromRoles } from './helper'

export const getPageThunk = () => (dispatch, getState) => {
	const accessToken = getState().core?.auth?.accessToken
	const pages = getPagesFromRoles(accessToken)
	dispatch(setPage(pages))
}
